import React from "react";
import Box from "@vapor/react-material/Box";
import Paper from "@vapor/react-material/Paper";
import TableContainer from "@vapor/react-material/TableContainer";
import TableHead from "@vapor/react-material/TableHead";
import Table from "@vapor/react-material/Table";
import TableRow from "@vapor/react-material/TableRow";
import TableCell from "@vapor/react-material/TableCell";
import TableBody from "@vapor/react-material/TableBody";
import Card from "@vapor/react-material/Card";
import CardMedia from "@vapor/react-material/CardMedia";
import Stack from "@vapor/react-material/Stack";
import { ProductProps } from "../types";

const Product = ({ product }: { product: ProductProps }) => {
  console.log("product", product);

  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: "20px",
        width: "fit-content",
      }}
    >
      <Stack padding="1rem" direction="row" spacing="1rem" alignItems="center">
        <Card
          sx={{
            maxWidth: 345,
            borderRadius: "10%",
          }}
        >
          <CardMedia
            alt="image"
            component="img"
            height="140"
            image={product.image}
          />
        </Card>
        <Box>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Vat Rate</TableCell>
                  <TableCell>Discount</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Net Price</TableCell>
                  <TableCell>Gross Price</TableCell>
                  <TableCell>Company</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={product.name}>
                  <TableCell component="th" scope="row">
                    {product.vatRate}
                  </TableCell>
                  <TableCell>{product.discount}</TableCell>
                  <TableCell>{product.price}</TableCell>
                  <TableCell>{product.netPrice}</TableCell>
                  <TableCell>{product.grossPrice}</TableCell>
                  <TableCell>{product.company}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Stack>
    </Paper>
  );
};

export default Product;
